module.exports = __webpack_public_path__ + "media/images/vp/icon.sharebutton.white-f103c09f8c1d64bde556646320c74898.svg";